import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'content-two-modal-mobile',
  templateUrl: './content-two-modal-mobile.component.html',
  styleUrls: ['./content-two-modal-mobile.component.scss'],
})
export class ContentTwoModalMobileComponent implements OnInit {
  @Input() valueCode = '';
  @Input() instructionOneMobile!: string;
  @Input() instructionTwoMobile!: string;
  @Input() instructionTreeMobile!: string;
  @Input() instructionFourMobile!: string;
  @Input() instructionFiveMobile!: string;
  @Input() instructionSixMobile!: string;
  constructor() {}

  ngOnInit(): void {}
}
